import { take, put } from 'redux-saga/effects';
import { routeActions } from 'redux-simple-router';

import { SUBMIT_VISIT } from '../constants/actionTypes';

export function *redirectOnSubmit() {
    while(true) {
        yield take(SUBMIT_VISIT.REQUEST);
        yield take(SUBMIT_VISIT.SUCCESS);
        yield put(routeActions.push('/visits'));
    }
}